import {
  AlignLeft,
  Clock,
  HelpCircle,
  LucideMessageSquare,
  LucideThumbsDown,
  LucideThumbsUp,
  Plus,
  Timer,
  X,
} from "lucide-react";
import { ApprovalStatus } from "@/prisma/generated/enums";

export const APP_NAME = "Cruize";
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL || process.env.NEXT_PUBLIC_WEB_URL || "http://localhost:3000";
export const DOCS_URL = process.env.NEXT_PUBLIC_DOCS_URL || "https://support.cruize.ai";
export const EMAIL_ALIAS_DOMAIN = `@${process.env.NEXT_PUBLIC_INVOICE_EMAIL_DOMAIN ?? "company.com"}`;
export const APP_EXCERPT = "Streamline your enterprise system integrations with CruizeAI";
export const APP_DESCRIPTION =
  "Connect and manage your enterprise systems through dedicated spaces. Each space provides specialized tools and workflows for different systems, making integration and automation seamless.";
export const USER_ROLES = [
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
];
export const USER_ROLES_V2 = {
  admin: {
    label: "Admin",
    value: "admin",
    description: "Full access to admin dashboard and settings.",
  },
  user: {
    label: "User",
    value: "user",
    description: "Basic access to user dashboard and settings.",
  },
};
export const DEFAULT_ORG_ROLES = {
  owner: {
    label: "Owner",
    value: "owner",
    description: "Full access to organization settings and data.",
  },
  admin: {
    label: "Admin",
    value: "admin",
    description: "Full access to organization settings and data.",
  },
  member: {
    label: "Member",
    value: "member",
    description: "Basic access to organization settings and data.",
  },
};

export const FEEDBACK_TYPES = [
  { value: "upvote", label: "Upvote", icon: LucideThumbsUp, color: "text-green-500" },
  { value: "downvote", label: "Downvote", icon: LucideThumbsDown, color: "text-red-500" },
  { value: "feedback", label: "General Feedback", icon: LucideMessageSquare, color: "text-blue-500" },
];
export const FEEDBACK_LABELS = {
  upvote: "Upvote",
  downvote: "Downvote",
  feedback: "General Feedback",
};
export const FEEDBACK_STATUS_LABELS = {
  NEW: "New",
  UNDER_REVIEW: "Under Review",
  RESOLVED: "Resolved",
  CLOSED: "Closed",
};

export const FEEDBACK_REASONS = [
  {
    value: "inaccurate",
    label: "Inaccurate",
    icon: X,
  },
  {
    value: "out_of_date",
    label: "Out of date",
    icon: Clock,
  },
  {
    value: "irrelevant",
    label: "Irrelevant",
    icon: HelpCircle,
  },
  {
    value: "missing_details",
    label: "Missing details",
    icon: Plus,
  },
  {
    value: "slow_timeout",
    label: "Slow / Timeout",
    icon: Timer,
  },
  {
    value: "bad_formatting",
    label: "Bad formatting",
    icon: AlignLeft,
  },
];

export const APPROVAL_STATUS_LABELS = {
  [ApprovalStatus.APPROVED]: "Approved",
  [ApprovalStatus.PENDING]: "Pending Approval",
  [ApprovalStatus.CHANGES_REQUESTED]: "Changes Requested",
  [ApprovalStatus.REJECTED]: "Rejected",
};

// UTC hours the approval-reminder cron runs at. The cron runs hourly, so every
// hour is a valid send tick; the settings UI offers each one (labeled in the
// org timezone) and the cron matches a schedule by comparing the current UTC
// hour against the stored sendHourUtc. Keep in sync with vercel.json (0 * * * *).
export const APPROVAL_REMINDER_CRON_HOURS_UTC = Array.from({ length: 24 }, (_, i) => i);

// The UTC hour the legacy daily reminder fires on, used as the default sendHourUtc.
export const APPROVAL_REMINDER_LEGACY_HOUR_UTC = 14;
